/** @jsxImportSource @emotion/react */

import Image from 'next/image';

import { media } from '@stories/theming/settings';
import imageLoader from '@utils/imageLoader';

import { SectionHeader, section } from './VitafyAboutUsPage';

const logos = [
  {
    url: 'https://cdn11.vitafy.de/vitafy/image/upload/v1728290404/vitafy/about-us/Creapure.svg',
    alt: 'Logo Creapure'
  },
  {
    url: 'https://cdn11.vitafy.de/vitafy/image/upload/v1728290404/vitafy/about-us/MagChel.svg',
    alt: 'Logo MagChel'
  },
  {
    url: 'https://cdn11.vitafy.de/vitafy/image/upload/v1728290404/vitafy/about-us/KSM66.svg',
    alt: 'Logo KSM66'
  },
  {
    url: 'https://cdn11.vitafy.de/vitafy/image/upload/v1728290403/vitafy/about-us/Organic.svg',
    alt: 'Logo Organic certification'
  },
  {
    url: 'https://cdn11.vitafy.de/vitafy/image/upload/v1728290404/vitafy/about-us/ResidueFree.svg',
    alt: 'Logo Residue Free certification'
  }
];

export const LogoGrid: React.FC = () => {
  return (
    <div>
      <ul
        css={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '1rem .5rem',
          justifyContent: 'space-evenly',
          marginTop: '3rem'
        }}
      >
        {logos.map((logo) => (
          <li key={logo.url} css={{ display: 'block', width: '200px', position: 'relative' }}>
            <Image
              loader={imageLoader}
              // @ts-expect-error static important
              css={{ height: 'auto !important', position: 'static !important' }}
              src={logo.url}
              alt={logo.alt}
              fill
              unoptimized={logo.url.endsWith('.svg')}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export const Guarantee: React.FC = () => {
  return (
    <section css={{ backgroundColor: 'hsl(198 42% 95%)', paddingBottom: '0rem' }}>
      <svg
        viewBox="0 0 100 11"
        xmlns="http://www.w3.org/2000/svg"
        css={{ display: 'block', height: 'auto', width: '100%' }}
      >
        <path d="M0 0 L100 0 L50 11 Z" fill="white" />
      </svg>
      <article css={{ ...section, [media('desktop')]: { padding: '5rem var(--offset) 2rem' } }}>
        <SectionHeader
          title={'Sicherheit zu 100%'}
          subtitle={`<p>
          Alle Produkte, die wir in unserem Shop verkaufen, werden regelmäßig im Labor auf Wirkstoffe, Mikro-
          und Makronährstoffe sowie weitere Indikatoren geprüft. So stellen wir sicher, dass Qualität,
          Reinheit und Sicherheit stets zu 100 % gewährleistet sind.
        </p>`}
        />
        <LogoGrid />
      </article>
    </section>
  );
};
